import { render, staticRenderFns } from "./busnessRankMgmt.vue?vue&type=template&id=768ba1cd&scoped=true"
import script from "./busnessRankMgmt.vue?vue&type=script&lang=js"
export * from "./busnessRankMgmt.vue?vue&type=script&lang=js"
import style0 from "./busnessRankMgmt.vue?vue&type=style&index=0&id=768ba1cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ba1cd",
  null
  
)

export default component.exports